import React, { forwardRef, useMemo, useCallback, useRef } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { find, isEmpty } from 'lodash';
import { FieldTypes } from 'utils/formUtils';
import message from "components/CustomMessage";
import GenericMappingForm from '../GenericMappingForm';
import { Form } from 'antd';
import { EmptyCancellableRequest } from 'restAPI';

function GoogleCloudRegistryMappingForm(props, ref) {
    // const [projectId, setProjectId] = useState()
    // const [tags, setTags] = useState([])
    const [form] = Form.useForm()
    const apiParamsRef = useRef({});
    const record = props.record
    if(record) {
      record.GCRProjectId = record?.image_id
    }

    const fetchRegions = useCallback(() => {
    const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolNameV2(
      "Google Cloud Registry",
      {
        login_id: props.loginConfigId,
        type: "region",
      }
    );
    const updatedPromise = promise
      .then((response) => {
        const { data } = response;
        return data?.projects;
      })
      .catch((err) => {
        message.error("Problem fetching regions", err);
      });

    return { promise: updatedPromise, cancel };
  }, [props.loginConfigId]);

  const onRegionChange = useCallback(
      (value, field) => {
        const { name } = field;
        const configurations = form.getFieldValue("configurations") || [];
        const updatedConfiguration = [...configurations];
        updatedConfiguration[name] = {
          ...updatedConfiguration[name],
          repos: [],
          image_id: [],
        };
        form.setFieldsValue({ configurations: updatedConfiguration });
      },
      [form]
  );

      const fetchRepos = useCallback((params) => {
        if(params?.region){
          const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolNameV2(
          "Google Cloud Registry",
          {
            login_id: props.loginConfigId,
            type: "repos",
            extraConfig: { region: params.region }
          }
        );
        const updatedPromise = promise
        .then((response) => {
          const { data } = response;
          return data?.projects;
        })
        .catch((err) => {
          message.error("Problem fetching repos", err);
        });
        return { promise: updatedPromise, cancel };
        }
        return EmptyCancellableRequest;
      }, [props.loginConfigId]);

  const onReposChange = useCallback(
      (value, field) => {
        const { name } = field;
        const configurations = form.getFieldValue("configurations") || [];
        const updatedConfiguration = [...configurations];
        updatedConfiguration[name] = {
          ...updatedConfiguration[name],
          image_id: [],
        };
        form.setFieldsValue({ configurations: updatedConfiguration });
      },
      [form]
  );
  const fetchImages = useCallback((params) => {
    if(!isEmpty(params?.repos)){
          const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolNameV2(
          "Google Cloud Registry",
          {
            login_id: props.loginConfigId,
            type: "images",
            extraConfig: params.repos === "all" ? { repos: [`${params.region}/all`] } : { repos: params.repos }
          }
        );
        const updatedPromise = promise
        .then((response) => {
          const { data } = response;
          return data?.projects;
        })
        .catch((err) => {
          message.error("Problem fetching images", err);
        });
        return { promise: updatedPromise, cancel };
    }
    return EmptyCancellableRequest;
    }, [props.loginConfigId]);

  // useEffect(() => {
  //   if(projectId || record){
  //   const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(toolName, { login_id: props.loginConfigId, name: projectId || record?.image_id });
  //   promise.then((response) => {
  //     const { projects } = response;
  //     setTags(projects);
  //   }).catch(() => {
  //     console.error();
  //   });
  //   return cancel;
  // }
  // }, [props.loginConfigId, projectId, record]);

  const normalizeImageForPayload = useCallback((image) => {
    if (!image) {
      return image;
    }
    const match = image.match(/^(.*)\s+\((.*)\)$/);
    if (!match) {
      return image;
    }
    const imageName = match[1];
    const imageSHA = (match[2] || "").replace(/[()]/g, "");
    return `${imageName}|${imageSHA}`;
  }, []);

  const normalizeImageForForm = useCallback((image) => {
    if (!image || !image.includes("|")) {
      return image;
    }
    const [imageName, rawSHA] = image.split("|");
    const imageSHA = (rawSHA || "").replace(/[()]/g, "");
    return `${imageName} (${imageSHA})`;
  }, []);

  // used to modify data when saving
  const getExtraFieldsData = useCallback((config) => {
    const { repos, region } = config;
    let imageId = config.image_id;
    let projectId = config.projectId;
    // image_id fetched as (for selected region+repo combos) imagename (imageSHA) and saved in format imagename|imageSHA;imagename2|image2SHA
    // while in edit mode format image name in expected displayble manner for dropdown
      projectId = props?.loginConfig.project_id;
      imageId = !isEmpty(imageId) ? imageId.map(normalizeImageForPayload).join(";") : "all";

    return ({
      projectId,
      image_id: imageId,
      repos: !isEmpty(repos) ? repos.join(";") : "all",
      region
      // tag_id: config.tag_id
    });
  }, [normalizeImageForPayload, props?.loginConfig?.project_id]) 

  // used to modify the response for form initialdata
  const parseExtraFieldsDataFromResponse = useCallback((config) => {
      const { repos, region, image_id} = config;
      return {
        repos: repos && repos !== "all" ? repos.split(";") : [],
        region,
        image_id: image_id && image_id !== "all" ? image_id.split(";").map(normalizeImageForForm) : [],
      };
    }, [normalizeImageForForm]);

  // const changeImageId = useCallback((value,field) => {
  //   const { name } = field;
  //   setProjectId(value)
  //   const data = form.getFieldsValue()
  //   const updatedData = [...data.configurations]
  //   updatedData[name] = {
  //     ...updatedData[name],
  //     tag_id: undefined
  //   }
  //   form.setFieldsValue({ configurations: updatedData})
  // },[setProjectId,form])

  const extraFields = useMemo(() => ([
    {
            name: "region",
            colSpan: 8,
            type: FieldTypes.SELECT,
            label: "Region",
            required: true,
            props: {
              api: fetchRegions,
              autoFocus: true,
              onChange: onRegionChange,
            },
          }, {
            name: "repos",
            colSpan: 8,
            type: FieldTypes.MULTI_SELECT,
            label: "Repos",
            props: {
              placeholder: "Leave blank to select all",
              api: fetchRepos,
              onChange: onReposChange,
              setExtraProps: (field, listField) => {
                const allConfigs = form.getFieldsValue().configurations || [];
                const currentConfiguration = allConfigs[listField.name] || {};
                const keyName = `${listField.name}_${currentConfiguration.region}`;
                const region = currentConfiguration.region;
                if (!apiParamsRef.current[keyName]) {
                  apiParamsRef.current[keyName] = { region: currentConfiguration.region }
                }
                return {
                  disabled: !region,
                  apiParams: apiParamsRef.current[keyName],
                };
          },
            },
          }, {
            name: "image_id",
            colSpan: 8,
            type: FieldTypes.MULTI_SELECT,
            label: "Image Name",
            props: {
              placeholder: "Leave blank to select all",
              api: fetchImages,
              setExtraProps: (field, listField) => {
                const allConfigs = form.getFieldsValue().configurations || [];
                const currentConfiguration = allConfigs[listField.name] || {};
                const region = currentConfiguration.region;
                const repos = currentConfiguration.repos;
                const keyName = `${region}_${repos?.join()}_${listField.name}`;
                const reposInAPI = region ? isEmpty(repos) || repos === "all" ? [`${region}/all`] : repos : [];
                if (!apiParamsRef.current[keyName]) {
                  apiParamsRef.current[keyName] = { repos: reposInAPI, region };
                }
                return {
                  disabled: !region,
                  apiParams: apiParamsRef.current[keyName],
                };
              },
            },
          }
    // {
    //   name: "tag_id",
    //   colSpan: '12',
    //   label: "Google Container Registry Tag",
    //   type: FieldTypes.SELECT,
    //   options: tags
    // }
  ]), [fetchRegions, onRegionChange, onReposChange, fetchRepos, fetchImages, form]);

  return (
    <GenericMappingForm
      {...props}
      ref={ref}
      form={form}
      title={"Map Google Cloud Registry Images"}
      getExtraFieldsData={getExtraFieldsData}
      parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
      extraFields={extraFields}
      record={record}
    />
  )
}

export default forwardRef(GoogleCloudRegistryMappingForm)
